var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-container',{staticClass:"app-layout"},[_c('el-aside',{class:{collapse:_vm.menuData.collapse}},[_c('Menu')],1),_c('el-main',[_c('header',[_c('AppHeader')],1),_c('main',[_c('transition',{attrs:{"name":"fade"}},[_c('router-view')],1)],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }